import React, { useRef } from "react";
import DatePicker from "react-datepicker";

function isValidUnixTimestamp(value) {
    // Check if it's a number
    if (typeof value !== 'number') {
      return false;
    }
  
    // Check if it's an integer (not a decimal)
    if (!Number.isInteger(value)) {
      return false;
    }
  
    // Optional: Check the range (you might adjust this range according to your needs)
    // Here assuming the timestamp is in milliseconds and within a reasonable range around the current time
    const minDate = new Date('1970-01-01').getTime(); // Earliest reasonable timestamp
    const maxDate = new Date('2100-01-01').getTime(); // Set some maximum reasonable timestamp
    if (value < minDate || value > maxDate) {
      return false;
    }
  
    return true;
  }
  

function getDateInt(input_date) {

    if (isValidUnixTimestamp(input_date)){
        input_date = new Date(input_date)
    }

    console.log('input_date',input_date)


    let year = (input_date.getFullYear()) + ''
    let monthInt = input_date.getMonth() + 1
    let month = ''
    if (monthInt < 10) {
        month = '0' + (input_date.getMonth() + 1)
    } else {
        month = (monthInt) + ''
    }
    let day = (input_date.getDate()) + ''
    if ((day * 1) < 10) { day = '0' + day }
    let wholeDate = (year + month + day) * 1
    return wholeDate

}

function addDays(date, days) {
    var result = new Date(date);
    result.setDate(result.getDate() + days);
    return result;
}

function DateStart(props) {
    const index = props.index;
    const safeState = props.safeState
    const messageValues = props.messageValues;
    const setMessageValues = props.setMessageValues;
    const updateParent = props.updateParent;
    const setCurrentFocus = props.setCurrentFocus
    const currentFocus = props.currentFocus
    const inputRef = useRef(null);
    const seasons = props.seasons
    if (inputRef.current && currentFocus =='dateStart') {
        inputRef.current.focus();
    }


    let tabIndex = 0
    if (props.tabIndex) { tabIndex = props.tabIndex }

    function TodaysDatePicker(props) {
        let seasons = props.seasons

        function dateChange(value) {
            let dayInt = getDateInt(value)
            const months = ["JAN", "FEB", "MAR", "APR", "MAY", "JUN", "JUL", "AUG", "SEP", "OCT", "NOV", "DEC"];
            let monthString = months[value.getMonth()]
            let day = value.getDate()
            if (day < 10) {
                day = '0' + day
            } else {
                day = day + ''
            }
            let dateString = day + monthString
            // console.log("dateString",dateString, 'index',index)
            messageValues['flightDetailLines'][index]['periodStart'] = dateString
            messageValues['flightDetailLines'][index]['periodStartInt'] = dayInt
            messageValues['flightDetailLines'][index]['periodStartObj'] = value
            messageValues['flightDetailLines'][index]['weekdays'] = [0, 0, 0, 0, 0, 0, 0]
            setMessageValues(messageValues)
            updateParent()
            setCurrentFocus('dateStart_'+index)
        }

        let todayDate = new Date()
        let minDate = todayDate
        let maxDate = todayDate
        // console.log('seasons',seasons)
        if (props.messageValues != undefined) {
            let selectedSeason = props.messageValues.header.season
            let seasonStart = seasons['periods'][selectedSeason]['start']
            // This check has been removed to facilitate past seasons
            // if (minDate < seasonStart) {
                minDate = seasonStart
            // }
            maxDate = seasons['periods'][selectedSeason]['end']
        }
        if (minDate == todayDate){
            minDate.setDate(minDate.getDate() - 4);    
        }

        // check the current date is within the season
        let periodStartInt = messageValues['flightDetailLines'][index]['periodStartInt']
        let seasonSelected = messageValues['header']['season']
        let seasonSelectedDates = props['seasons']['periods'][seasonSelected]
        let seasonStart = seasonSelectedDates['start']
        let seasonStartInt = getDateInt(seasonStart)
        let seasonEnd = seasonSelectedDates['end']
        let seasonEndInt = getDateInt(seasonEnd)

        let dateOk = periodStartInt >= seasonStartInt && periodStartInt <= seasonEndInt
        if (!dateOk) {
            messageValues['flightDetailLines'][index]['periodStart'] = ''
            messageValues['flightDetailLines'][index]['periodStartObj'] = null
            console.log('Date not valid, ',messageValues['flightDetailLines'][index]['periodStartInt'],'seasonStartInt',seasonStartInt,'seasonEndInt',seasonEndInt)
            // setMessageValues(messageValues)
        }
        if (safeState == false) {
            maxDate = addDays(new (Date), 365)
        }
        let hasFocus = currentFocus === 'dateStart_'+index ? true : false

        return (
            <DatePicker 
                className="form-control" 
                maxDate={maxDate} 
                minDate={minDate} 
                dateFormat="ddMMM" 
                onChange={dateChange} 
                value={messageValues['flightDetailLines'][index]['periodStart']} 
                tabIndex={tabIndex} 
                onInputClick={()=>{setCurrentFocus('dateStart_'+index)}} 
                ref={inputRef} 
                preventOpenOnFocus={true}
                autoFocus={hasFocus}

            />
        );
    }


    return (    
        <>
            <p className="text-muted mb-0 small">Date</p>
            <TodaysDatePicker messageValues={messageValues} seasons={seasons}></TodaysDatePicker>
        </>
    );
}

export default DateStart